export default {
  generic: {
    loading: "Loading...",
    confirm: {
      areYouSure: "Are you sure?",
      areYouSureDelete: "Are you sure you want to delete this?",
      yesDelete: "Yes, delete it",
      cancel: "Cancel",
      close: "Close",
      okay: "Okay",
      confirm: "Confirm",
    },
    accountSelection: {
      placeholder: "Select account",
      advancedSearchSubtitle: "Select an account from the table below",
      advancedSearchTitle: "Select { title }",
    },
    accountSummaryTable: {
      actionsHeader: "Actions",
    },
    back: "Back",
    delete: "Delete",
    messages: {
      usdValuationsEstimate: "USD valuations displayed are estimates",
      copiedToClipboard: "Copied to clipboard",
      errorLoadingRequiredData:
        "Error loading the required data. Try refreshing the page or contact a system administrator.",
      dataMayBeStale: "Your latest change may take a moment to appear",
    },
    tbc: "TBC",
  },
  form: {
    labels: {
      account: "Account",
      accountFrom: "From Account",
      accountTo: "To Account",
      advancedSearch: "Advanced Search",
      amount: "Amount",
      asset: "Asset",
      lmaxEntity: "LMAX Entity",
      entity: "Entity (CCID)",
      optional: "(optional)",
      pendingSelection: "Pending selection",
      product: "Product",
      reference: "Reference",
      reviewStepButton: "Proceed to Review",
      transactionId: "Transaction ID",
    },
    messages: {
      accountRequired: "Account is required",
      entityRequired: "Entity (CCID) is required",
      amountOverMax: "Amount exceeds available balance",
      amountGreaterThanZero: "Amount must be greater than 0",
      amountRequired: "Amount is required",
      assetRequired: "Asset is required",
    },
    placeholders: {
      selectEntity: "Select an entity",
    },
    buttons: {
      proceedToReview: "Proceed to Review",
    },
    modal: {
      close: "Close",
      advancedSearchTitleStart: "Select",
      advancedSearchTitleEnd: "Account",
      advancedSearchSubtitle:
        "Find the account you want to select either by searching or filtering the columns",
      searchPlaceholder: "Search",
    },
  },
  sidebar: {
    dashboard: "Dashboard",
    transfer: "Transfer",
    trade: "Trade",
    transactions: "Transactions",
    auditLogs: "Audit Logs",
    approvals: "Approvals",
    configuration: "Configuration",
    transfers: "Transfers",
    charges: "Charges",
    mapping: "Mapping",
    manageFunds: "Manage Funds",
    withdrawal: "Withdrawal",
    supportAndDocs: "Support & Docs",
    logoAlt: {
      platform: "LMAX One Platform Portal",
      client: "LMAX One Client Portal",
    },
  },
  dashboard: {
    greeting: `Hello `,
    tabs: {
      accounts: "Accounts",
      assets: "Assets",
    },
    cards: {
      totalValuation: "Total Valuation",
      totalCredit: "Total Credit",
      totalEquity: "Total Equity",
      totalMargin: "Total Margin",
      totalsAcrossEntities: "Totals Across Entities",
      fiatVsDigital: "Fiat vs Digital",
      fiat: "Fiat",
      digital: "Digital",
      allocations: "Allocations",
      assetAllocation: "Asset Allocation",
    },
  },
  transactions: {
    tables: {
      title: `Transactions in`,
      id: "TxID",
      workflowId: "Workflow ID",
      lastUpdated: "Created At (UTC)",
      startingTime: "Created At (UTC)",
      startingTimeFilterPlaceholder: "Select date range",
      requester: "Requester",
      transactionType: "Type",
      cashflowType: "Cashflow Type",
      workflowSummaryType: "Workflow Summary Type",
      accountSide: "Account Side",
      sourceType: "Source Type",
      doubleEntryId: "Double Entry ID",
      asset: "Asset",
      entity: "Entity",
      account: "Account",
      direction: "Direction",
      actions: "Actions",
      fromEntity: "From Entity",
      toEntity: "To Entity",
      fromCustomer: "From Customer",
      toCustomer: "To Customer",
      fromProduct: "From Product",
      toProduct: "To Product",
      fromAccount: "From Account",
      toAccount: "To Account",
      amount: "Amount",
      status: "Status",
      reference: "Reference",
      searchPlaceholder: "Search by Transaction ID",
      transactionHash: "Transaction Hash",
      allTransactionTypes: "All types",
      transactionTypesSelectedCount: "{count} selected",
      transactionTypes: {
        broker_to_broker: "Broker To Broker",
        inter_account: "Inter Account",
      },
      exportError: "Failed to export transactions. Please try again.",
    },
    accountSides: {
      asset: "Asset",
      liability: "Liability",
      revenue: "Revenue",
    },
    sourceTypes: {
      broker_to_broker_transfer: "Broker-to-broker transfer",
      deposit: "Deposit",
      dfx_commission: "DFX commission",
      fx_conversion: "FX conversion",
      inter_account_transfer: "Inter-account transfer",
      manual_digital_deposit: "Manual digital deposit",
      manual_digital_withdrawal: "Manual digital withdrawal",
      transfer: "Transfer",
      withdrawal: "Withdrawal",
    },
    cards: {
      totalValuation: "Total Valuation",
      fiatVsDigital: "Fiat vs Digital",
      fiat: "Fiat",
      digital: "Digital",
      allocations: "Allocations",
      assetAllocation: "Asset Allocation",
    },
    messages: {
      transactionSuccessTitle: "Transaction pending",
      transactionSuccessMessage:
        "Your transaction is awaiting approval. Transaction ID: { id }",
      copyTransactionId: "Copy Transaction ID",
      transactionSuccessMessageV2:
        "Your transaction is awaiting approval. Workflow ID: { id }",
      copyWorkflowId: "Copy Workflow ID",
    },
    tray: {
      title: "Transaction Details",
      copyLink: "Copy transaction page link",
      openInNewTab: "Open in new tab",
      export: "Export Transaction",
      seeAccountForFullBreakdown: "See Account for full breakdown",
      credit: "Credit",
      debit: "Debit",
      cashflowTypes: {
        broker_deposit: "Broker deposit",
        broker_withdrawal: "Broker withdrawal",
        broker_internal_account_transfer: "Broker internal account transfer",
        broker_to_broker_transfer: "Broker-to-broker transfer",
        conversion_fee: "Conversion fee",
        conversion_revenue: "Conversion revenue",
        conversion_settlement: "Conversion settlement",
        custody_deposit: "Custody deposit",
        custody_withdrawal: "Custody withdrawal",
        custody_transfer: "Custody transfer",
        deposit_fee: "Deposit fee",
        withdrawal_fee: "Withdrawal fee",
        deposit_revenue: "Deposit revenue",
        withdrawal_revenue: "Withdrawal revenue",
      },
      fields: {
        date: "Date (UTC)",
        time: "Time (UTC)",
        transactionId: "Transaction ID",
        workflowId: "Workflow ID",
        doubleEntryId: "Double Entry ID",
        type: "Type",
        asset: "Asset",
        symbol: "Symbol",
        direction: "Direction",
        accountSide: "Account Side",
        sourceId: "Source ID",
        sourceType: "Source Type",
        transactionHash: "Transaction Hash",
        sourceSystemId: "Source System ID",
        amount: "Amount",
        cashflowType: "Cashflow Type",
        requester: "Requester",
        entity: "Entity",
        product: "Product",
        customer: "Customer",
        account: "Account",
        counterparty: "Counterparty",
        fiatValuation: "Fiat Valuation",
        valuationPrice: "Valuation Price",
        valuationCurrencyCode: "Valuation Currency",
        reference: "Reference",
        createdAt: "Created at (UTC)",
        lastUpdated: "Last updated at (UTC)",
        assetBalance: "Asset Balance",
        executionId: "Execution ID",
        orderId: "Order ID",
        commission: "Commission",
        debitCredit: "Debit Credit",
      },
    },
  },
  tableTrayDetails: {
    transactionId: "Transaction ID",
    entity: "Entity",
    entityNumber: "Entity Number",
    account: "Account",
    accountNumber: "Account Number",
    moreInformation: "More Information",
    seeInAuditLog: "See in Audit Log",
  },
  auditLogs: {
    pageTitle: "Audit Logs",
    individualPageTitle: "Individual Audit Log",
    banner: {
      defaultTitle: "Transaction initiated",
      tradeTitle: "Trade initiated",
      withdrawalTitle: "Withdrawal initiated",
      message: "Your transaction is awaiting approval. Workflow ID: { id }.",
      copyId: "Copy Workflow ID",
    },
    tables: {
      workflowId: "Workflow ID",
      workflowType: "Type",
      status: "Status",
      entity: "Entity",
      startedAt: "Created At (UTC)",
      description: "Description",
      actions: "Actions",
      view: "View",
      searchPlaceholder: "Search",
      allWorkflowTypes: "All types",
      workflowTypesSelectedCount: "{count} selected",
    },
    workflowStatuses: {
      in_progress: "In progress",
      completed: "Completed",
      failed: "Failed",
    },
    workflowTypes: {
      manual_adjustment: "Manual adjustment",
      auto_transfer: "Auto-transfer",
      auto_conversion: "Auto-conversion",
    },
    workflowSummaryTypes: {
      deposit_auto_transfer: "Deposit auto-transfer",
      withdrawal_auto_transfer: "Withdrawal auto-transfer",
      deposit_auto_conversion: "Deposit auto-conversion",
      withdrawal_auto_conversion: "Withdrawal auto-conversion",
      manual_internal_account_transfer: "Manual internal account transfer",
      manual_broker_to_broker_transfer: "Manual broker-to-broker transfer",
      manual_trade: "Manual trade",
    },
    tray: {
      title: "Audit Log Entry Details",
      copyLink: "Copy link to log page",
      openInNewTab: "Open in new tab",
      seeAccountForFullBreakdown: "See Account for full breakdown",
    },
    workflowTray: {
      title: "Workflow Details",
      copyLink: "Copy link to log page",
      openInNewTab: "Open in new tab",
      workflowId: "Workflow ID",
      entity: "Entity",
      entityNumber: "Entity Number",
      description: "Description",
      type: "Type",
      requester: "Requester",
      startedAt: "Started",
      auditTrail: "Workflow Audit Trail",
    },
    workflowAuditTrail: {
      time: "Created At (UTC)",
      workflowTypeLabel: "Workflow Type",
      type: "Type",
      status: "Status",
      searchPlaceholder: "Search",
    },
    trailRow: {
      shortTypeB2b: "B2B",
      shortTypeFee: "Fee",
      shortTypeCustodian: "Cust.",
      shortTypeLedger: "Ledger",
      shortTypeEvent: "Event",
      custodianProductName: "Custodian",
      emDash: "—",
      statusFailed: "failed",
      statusSucceeded: "succeeded",
      statusInitiated: "initiated",
      statusReceived: "received",
    },
    trayMoreInfo: {
      fields: {
        auditRecordType: "Audit record type",
        fromProduct: "From product",
        fromAccount: "From account",
        custodianTransferProduct: "Custodian transfer product",
        custodianTransferAccount: "Custodian transfer account",
        toProduct: "To product",
        toAccount: "To account",
        asset: "Asset",
        amount: "Amount",
        sellAmount: "Sell amount",
        domainSymbol: "Domain symbol",
        externalRequestId: "External request ID",
        custodianAssetName: "Custodian asset name",
        custodianBlockchain: "Custodian blockchain",
        billingProduct: "Billing product",
        billingAccount: "Billing account",
        revenueProduct: "Revenue product",
        revenueAccount: "Revenue account",
        feePerMillion: "Fee per million",
        minimumFee: "Minimum fee",
        status: "Status",
        symbol: "Symbol",
        purpose: "Purpose",
        direction: "Direction",
        platformRequestId: "Platform request ID",
        errorCode: "Error code",
        errorMessage: "Error message",
        transferAmount: "Transfer amount",
        transferAsset: "Transfer asset",
        fundsSourceProduct: "Funds source product",
        fundsSourceAccount: "Funds source account",
        custodianWithdrawalProduct: "Custodian withdrawal product",
        custodianWithdrawalAccount: "Custodian withdrawal account",
        address: "Address",
        addressReference: "Address reference",
        externalWithdrawalRequestId: "External withdrawal request ID",
        custodianWithdrawalId: "Custodian withdrawal ID",
        travelRuleOriginatorMatchesBeneficiary:
          "Originator matches beneficiary",
        travelRuleOriginatorClientReference: "Originator client reference",
        travelRuleOriginatorName: "Originator name",
        travelRuleOriginatorAddress: "Originator address",
        travelRuleBeneficiaryClientReference: "Beneficiary client reference",
        travelRuleBeneficiaryName: "Beneficiary name",
        travelRuleBeneficiaryAddress: "Beneficiary address",
        amountToBuy: "Amount to buy",
        expiryTimeMillis: "Expiry (epoch millis)",
        assetToUsdPrice: "Asset to USD price",
        billingCurrencyPrice: "Billing currency price",
        fee: "Fee",
        billingDomainSymbol: "Billing domain symbol",
        convertedAmount: "Converted amount",
        topUpDirection: "Top-up direction",
        sourceAmount: "Source amount",
        sourceAsset: "Source asset",
        targetAsset: "Target asset",
        clientAmount: "Client amount",
        clientSourceSymbol: "Client source symbol",
        clientTargetSymbol: "Client target symbol",
        conversionFeeBillingAmount: "Conversion fee (billing)",
        topUpBillingAmount: "Top-up (billing)",
        revenueAmount: "Revenue amount",
        settlementAmount: "Settlement amount",
        custodyProduct: "Custody product",
        custodyAccount: "Custody account",
        externalProduct: "External product",
        externalAccount: "External account",
        custodyCustomerId: "Custody customer ID",
        custodyToAccount: "Custody to account",
        custodianInternalTransferAmount: "Custodian internal transfer amount",
        externalDomainSymbol: "External domain symbol",
        usdToFeeAssetPrice: "USD to fee asset price",
        assetToFeeAssetPrice: "Asset to fee asset price",
        chargingModel: "Charging model",
        settlementPriceType: "Settlement price type",
        clientProduct: "Client product",
        clientAccount: "Client account",
        settlementAccount: "Settlement account",
        omniaSourceSymbol: "Omnia source symbol",
        omniaTargetSymbol: "Omnia target symbol",
        product: "Product",
        account: "Account",
        custodianTransferId: "Custodian transfer ID",
        instructionId: "Instruction ID",
        sellingAsset: "Selling asset",
        buyingAsset: "Buying asset",
        amountToSell: "Amount to sell",
        amountReceived: "Amount received",
        feePaid: "Fee paid",
        omniaStatus: "Omnia status",
        callbackUrl: "Callback URL",
        entity: "Entity",
        fromEntity: "From entity",
        toEntity: "To entity",
        fromCustomerId: "From customer ID",
        toCustomerId: "To customer ID",
        requester: "Requester",
        reference: "Reference",
        requiresApproval: "Requires approval",
        workflowId: "Workflow ID",
        assetName: "Asset name",
        notificationType: "Notification type",
        blockchain: "Blockchain",
        clientReference: "Client reference",
        fromAddress: "From address",
        toAddress: "To address",
        blockchainTransactionId: "Blockchain transaction ID",
        depositRequestReference: "Deposit request reference",
        accountId: "Account ID",
        depositTimestamp: "Deposit received at (UTC)",
      },
      enums: {
        auditRecordType: {
          deposit_callback_received: "Deposit callback received",
          deposit_billing_initiated: "Deposit billing initiated",
          custody_withdrawal_initiated: "Custody withdrawal initiated",
          inter_account_manual_transfer_initiated:
            "Inter-account manual transfer initiated",
          broker_to_broker_manual_transfer_initiated:
            "Broker-to-broker manual transfer initiated",
          transfer_completed: "Transfer completed",
          trade_initiated: "Trade initiated",
          trade_completed: "Trade completed",
          workflow_completed: "Workflow completed",
          broker_transfer: "Broker transfer",
          custodian_internal_transfer: "Custodian internal transfer",
          custody_withdrawal_request: "Custody withdrawal request",
          custody_fee_calculation: "Custody fee calculation",
          trade_amounts_calculation: "Trade amounts calculation",
          omnia_quote: "Omnia quote",
          omnia_action_quote: "Omnia action quote",
          omnia_order: "Omnia order",
          omnia_withdrawal_notification: "Omnia withdrawal notification",
          external_callback: "External callback",
        },
        auditStatus: {
          succeeded: "Succeeded",
          failed: "Failed",
        },
        direction: {
          debit: "Debit",
          credit: "Credit",
        },
        brokerTransferPurpose: {
          debit_client_account: "Debit client account",
          credit_client_account: "Credit client account",
          debit_settlement_account: "Debit settlement account",
          credit_settlement_account: "Credit settlement account",
          debit_conversion_billing_account: "Debit conversion billing account",
          credit_conversion_revenue_account:
            "Credit conversion revenue account",
          debit_deposit_billing_account: "Debit deposit billing account",
          credit_deposit_revenue_account: "Credit deposit revenue account",
          settle_billing_account_topup: "Settle billing account top-up",
          manual_digital_deposit: "Manual digital deposit",
          manual_digital_withdrawal: "Manual digital withdrawal",
          inter_account_debit: "Inter-account debit",
          inter_account_credit: "Inter-account credit",
          broker_to_broker_debit: "Broker-to-broker debit",
          broker_to_broker_credit: "Broker-to-broker credit",
        },
        externalCallbackPurpose: {
          deposit_callback: "Deposit callback",
          withdrawal_callback: "Withdrawal callback",
        },
        autoConversionChargingModel: {
          billing_account: "Billing account",
          commission_spread: "Commission spread",
        },
        autoConversionSettlementPriceType: {
          one_to_one: "One to one",
          market_price: "Market price",
          market_price_plus_spread: "Market price plus spread",
        },
        requiresApproval: {
          true: "Yes",
          false: "No",
        },
        originatorMatchesBeneficiary: {
          true: "Yes",
          false: "No",
        },
      },
    },
  },
  accounts: {
    tabs: {
      assets: "Assets",
      transactions: "Transactions",
      settings: "Settings",
      auditLogs: "Audit Logs",
    },
    settings: {
      convertAndAllocate: "Convert & Allocate",
      tabs: {
        webhooks: "Webhooks",
      },
      autoAllocation: "Auto Allocation",
      enableAutoAllocation: "Enable Auto Allocation",
      enableAutoAllocationTooltip:
        "Automatically transfer funds from this account to your designated account",
      whenFundsLandIn: "When funds land in this account",
      moveThemTo: "move them to",
      destinationLabel: "Destination account",
      destinationPlaceholder: "Select destination account",
      advancedSearchTitle: "Find destination account",
      advancedSearchSubtitle: "Select an account from the table below",
      save: "Save",
      saveSuccess: "Settings saved successfully",
      allocationCleared: "Auto-allocation turned off",
      saveError: "Failed to save settings",
      saveIncompleteRows:
        "Some rows are incomplete. Please fill in all fields or remove incomplete rows before saving.",
      saveMissingDefaultAsset:
        "Please select a default conversion asset before saving.",
      defaultConversionAssetRequired: "Select a default conversion asset",
      saveMissingDestination:
        "Please select a destination account before saving.",
      destinationRequired: "Select a destination account",
      saveMissingRequiredFields:
        "Please fill in all required fields before saving.",
      unsavedChangesHeader: "You have unsaved changes",
      unsavedChangesMessage:
        "Are you sure you want to leave? Any unsaved changes will be lost.",
      unsavedChangesAccept: "Leave without saving",
      unsavedChangesReject: "Stay on page",
      autoConversion: "Auto Conversion",
      enableAutoConversion: "Enable Auto Conversion",
      enableAutoConversionTooltip:
        "Automatically exchange transferred funds into your selected asset",
      byDefaultConvertThemTo: "by default convert them to",
      conversionOverrides: "Conversion Overrides",
      conversionOverridesHelperPrefix:
        "All currency by default is converted to",
      conversionOverridesHelperSuffix: "unless overridden below",
      conversionOverridesHelperNoDefault:
        "All currency by default is not converted",
      ifThisAccountReceives: "if this account receives",
      then: "then",
      to: "to",
      convertIt: "Convert it",
      keepIt: "Don't convert it",
      addAnotherRule: "Add another rule",
      deleteRuleConfirmHeader: "Are you sure you want to delete this?",
      deleteRuleConfirmMessage: "Once deleted it cannot be restored",
      deleteRuleConfirmAccept: "Yes confirm delete",
      deleteRuleConfirmReject: "No, cancel and go back",
      webhooks: {
        title: "Webhooks",
        save: "Save",
        inboundNotificationEndpoint: "Inbound Notification Endpoint",
        inboundNotificationEndpointTooltip:
          "The URL we'll call to notify you when a transaction has been received or completed",
        depositCallbackUrl: "Deposit Callback URL",
        depositCallbackUrlTooltip:
          "Callback URL to configure in LMAX Custody — contact the LMAX team for support",
        withdrawalCallbackUrl: "Withdrawal Callback URL",
        withdrawalCallbackUrlTooltip:
          "Callback URL to configure in LMAX Custody — contact the LMAX team for support",
        invalidUrl: "Please enter a valid URL (e.g. https://example.com).",
      },
    },
    tables: {
      account: "Account",
      entity: "Entity",
      customer: "Customer",
      lmaxEntity: "LMAX Entity",
      product: "Product",
      assets: "Assets",
      accountCurrency: "Account Currency",
      valuationTotalCredit: "Credit (USD)",
      valuationTotalEquity: "Equity (USD)",
      valuationTotalMargin: "Margin (USD)",
      valuationTotalCash: "Cash (USD)",
      valuationTotalAvailable: "Available To Withdraw (USD)",
      accountValuationTotalCredit: "Credit",
      accountValuationTotalEquity: "Equity",
      accountValuationTotalMargin: "Margin",
      accountValuationTotalCash: "Cash",
      accountValuationTotalAvailable: "Available To Withdraw",
      actionsButton: "...",
    },
    tooltips: {
      customer:
        "The unique customer ID linked to this account (product-based).",
      account: "The account name and unique account ID.",
      product: "The LMAX product type associated with this account",
      lmaxEntity: "The LMAX legal entity under which this account is held",
      assets:
        "Assets held in this account, such as crypto (e.g. BTC) or fiat (e.g. USD)",
      entity: "The legal entity associated with the Account & Customer.",
      valuationTotalEquity:
        "The total value of all assets in this account, including balances and unrealised trading P&L. Converted to USD (estimated)",
      valuationTotalAvailable:
        "Estimated USD value available for withdrawal or transfer.",
      valuationTotalCredit:
        "The borrowing limit or credit facility assigned to this account converted to USD (estimated)",
      valuationTotalMargin:
        "Required margin to support open positions converted to USD (estimated)",
      valuationTotalCash: "Total cash converted to USD equivalent (estimated)",
      accountValuationTotalEquity:
        "The total value of all assets in this account, including balances and unrealised trading P&L, in account currency)",
      accountValuationTotalAvailable:
        "Estimated value available for withdrawal or transfer, in account currency",
      accountValuationTotalCredit:
        "The borrowing limit or credit facility assigned to this account, in account currency",
      accountValuationTotalMargin:
        "Required margin to support open positions, in account currency",
      accountValuationTotalCash: "Total cash, in account currency",
    },
  },
  account: {
    meta: {
      accountNumber: "Account number",
    },
    cards: {
      total: {
        title: "Available to Withdraw (USD)",
      },
      totals: {
        title: "Totals",
        credit: "Total Credit",
        equity: "Total Equity",
        margin: "Total Margin",
      },
      allocations: {
        title: "Allocations",
      },
    },
    actions: {
      transferFrom: "Transfer from",
    },
  },
  assets: {
    tables: {
      title: "Assets in",
      symbol: "Assets",
      cashAmount: "Cash (Native)",
      cashValuation: "Cash (USD)",
      creditAmount: "Credit (Native)",
      creditValuation: "Credit (USD)",
      allocations: "Allocations",
    },
    tooltips: {
      symbol:
        "Assets held in this account, such as crypto (e.g. BTC) or fiat (e.g. USD)",
      cashAmount:
        "The account's cash shown in the native currency or asset denomination (e.g. BTC, EUR, GBP)",
      cashValuation: "Total cash converted to USD equivalent (estimated).",
      creditAmount:
        "The account's credit shown in the native currency or asset denomination (e.g. BTC, EUR, GBP)",
      creditValuation: "Total credit converted to USD equivalent (estimated).",
      allocations:
        "Total percentage of portfolio allocated to a specific asset",
    },
  },
  withdrawal: {
    titles: {
      page: "Withdrawal",
      pageDigital: "Make a Digital Withdrawal",
      setup: "Setup Withdrawal",
      review: "Review & Confirm",
      submitted: "Submitted",
      amount: "Amount",
      amountYouWithdraw: "Amount you withdraw",
      amountToSell: "Amount to sell for withdrawal",
      accountAndSource: "Account & Source",
      assetAndAmount: "Asset & Amount",
      assetAndAmountHintWithdraw:
        "Default Withdrawal — enter the amount you want to withdraw",
      assetAndAmountHintSell:
        "Swapped Withdrawal — enter the amount you want to sell to fund the withdrawal",
      withdrawalAddress: "Withdrawal Address",
      travelRule: "Travel Rule",
      originatorDetails: "Originator Details",
      beneficiaryDetails: "Beneficiary Details",
      advancedSearchTitle: "Find account",
      advancedSearchSubtitle: "Select an account from the table below",
    },
    countryGroups: {
      commonlyUsed: "Commonly Used",
      separator: "-------------",
    },
    labels: {
      proceedToReview: "Proceed to review",
      cancel: "Cancel",
      confirmWithdrawal: "Confirm",
      productSource: "Product / Source",
      account: "Account",
      externalRequestId: "External Request ID",
      assetSymbol: "Asset Symbol",
      blockchain: "Blockchain",
      assetToWithdraw: "Asset to Withdraw",
      assetToConvert: "Asset to Convert",
      swapToSellAmount: "Switch to entering the amount you want to sell",
      swapToWithdrawAmount:
        "Switch to entering the amount you want to withdraw",
      amount: "Amount",
      balanceBefore: "Account balance before withdrawal",
      balanceAfter: "Account balance after withdrawal",
      balanceBeforeTooltip:
        "Your current account balance before this withdrawal is processed.",
      balanceAfterTooltip:
        "Your expected account balance once this withdrawal is complete.",
      assetWithdrawalAmount: "Asset withdrawal amount",
      assetBalanceBefore: "Asset balance before transfer",
      assetBalanceAfter: "Asset balance after transfer",
      percentOfTotal: "of total",
      beforeAndAfterBalance: "Before and after balance",
      recipientAddress: "Recipient withdrawal address",
      addressReference: "Address reference",
      originatorMatchesBeneficiary: "Originator matches beneficiary?",
      originatorMatchesBeneficiaryTooltip:
        "Turn on if the originator of this withdrawal is the same person or entity as the registered beneficiary. Originator details are not required when this is on.",
      optionalBadge: "Optional",
      originatorClientReference: "Originator client reference",
      beneficiaryClientReference: "Beneficiary client reference",
      beneficiaryStreetAddress: "Beneficiary street address",
      personType: "Person type",
      personTypeTooltip:
        "Indicates whether the recipient is a natural person (Individual) or a legal entity (Corporation).",
      personTypeNatural: "Natural",
      personTypeLegal: "Legal",
      firstName: "First name",
      secondName: "Second name",
      legalPersonName: "Legal entity name",
      originatorStreetAddress: "Originator street address",
      buildingNumber: "Building number",
      buildingName: "Building name",
      streetName: "Street name",
      town: "Town",
    },
    hints: {
      externalRequestId: "Max 32 characters",
      amount: "Up to 5 decimal places",
      addressReference: "Max 32 characters",
      beneficiaryOptional:
        "Only needed if beneficiary details have changed since the withdrawal address was first registered.",
    },
    placeholders: {
      selectProduct: "Select product",
      selectAccount: "Select account",
      selectAssetSymbol: "Select Asset Symbol",
      selectBlockchain: "Select Blockchain",
      selectConvertAsset: "Select asset",
      externalRequestId: "Eg. Digital withdrawal to external account",
      amount: "0",
      recipientAddress: "Eg. 0x0Fca99b98BBFA04680409fDA93399B81B88BBb89",
      addressReference: "Eg. ABC_12345",
      originatorClientReference: "e.g. Client PII 7543562",
      beneficiaryClientReference: "e.g. Client PII 7543562",
      firstName: "e.g. Benny",
      secondName: "e.g. Fishery",
      legalPersonName: "e.g. Acme Ltd",
      buildingNumber: "Building number",
      buildingName: "Building name",
      streetName: "Street name",
      town: "Town",
      selectCountry: "Select country",
    },
    messages: {
      productRequired: "Product is required",
      accountRequired: "Account is required",
      externalRequestIdMaxLength:
        "External Request ID must be 32 characters or fewer",
      assetSymbolRequired: "Asset is required",
      blockchainRequired: "Blockchain is required",
      amountRequired: "Amount is required",
      amountGreaterThanZero: "Amount must be greater than 0",
      amountExceedsBalance: "Amount exceeds available balance",
      recipientAddressRequired: "Recipient withdrawal address is required",
      addressReferenceRequired: "Address reference is required",
      addressReferenceMaxLength:
        "Address reference must be 32 characters or fewer",
      amountMaxDecimals: "Amount must have at most 5 decimal places",
      originatorClientReferenceRequired:
        "Originator client reference is required",
      beneficiaryClientReferenceRequired:
        "Beneficiary client reference is required",
      firstNameRequired: "First name is required",
      legalPersonNameRequired: "Legal entity name is required",
      buildingRequired: "Either building number or building name is required",
      buildingBothProvided:
        "Provide either building number or building name, not both",
      streetNameRequired: "Street name is required",
      countryRequired: "Country is required",
      withdrawalFailTitle: "Withdrawal failed",
      noFormData: "No withdrawal data available",
    },
    review: {
      yes: "Yes",
      no: "No",
      empty: "—",
      noFormData: "No withdrawal data to review.",
    },
  },
  transfer: {
    titles: {
      accounts: "Where from and to?",
      amount: "How much?",
      review: "Review & Confirm",
      setup: "Setup transfer",
      successStep: "Submitted",
    },
    summary: {
      accountBalanceBefore: "Account balance before transfer",
      accountBalanceAfter: "Account balance after transfer",
      assetSelected: "Asset selected",
      assetAmount: "Asset transfer amount",
      assetBalanceBefore: "Asset balance before transfer",
      assetBalanceAfter: "Asset balance after transfer",
      viewFullBreakdown: "See account for full breakdown",
    },
    labels: {
      confirmTransfer: "Confirm transfer",
      reviewReference: "Payment reference",
      requester: "Requester",
    },
    tooltips: {
      accountFrom: "Select the account you want to transfer funds from",
      accountTo: "Select the account that will receive the funds",
      asset:
        "Choose the asset type to transfer, such as digital tokens (e.g. BTC) or fiat currencies (e.g. USD).",
      amount:
        "Enter the Native amount of the selected asset you would like to transfer",
      reference:
        "Add a reference or note for internal tracking (e.g. client ID)",
      usdValuations:
        "USD conversions are approximations for guidance only and may vary due to price movements, spreads, and refresh delays. Final USD value is determined at execution.",
    },
    messages: {
      transferFailTitle: "Transfer failed",
      accountHasNoAssets: "From account has no assets",
    },
  },
  trade: {
    titles: {
      page: "Trade",
      pageSubtitle:
        "Confirm the details below are correct before submitting your trade",
      productSource: "Select Product / Source",
      account: "Select account",
      youSell: "You sell",
      youBuy: "You buy",
      amount: "Amount",
      conversionAmount: "Conversion Amount",
      breakdown: "Breakdown",
    },
    labels: {
      executeTrade: "Double click to execute trade",
      executing: "Executing",
      updatingQuote: "Updating…",
      advancedSearch: "Advanced search",
      ofTotal: "of total",
      accountBalanceBefore: "Account balance before trade",
      accountBalanceAfter: "Account balance after trade",
      swapDirections: "Swap sell and buy",
    },
    placeholders: {
      product: "Select product",
      account: "Select account",
      asset: "Select asset",
      amount: "0.00",
      conversionAmount: "0.00",
    },
    tooltips: {
      conversionAmount:
        "Estimated value only. Final execution price is subject to market conditions and may differ from this amount.",
    },
    messages: {
      tradeFailTitle: "Trade failed",
    },
  },
  transaction: {
    titles: {
      tray: "Transaction details",
      details: "Details",
      moreDetails: "More details",
    },
  },
  configurations: {
    title: "Configuration",
    chargesTitle: "Charges",
    tabs: {
      transfers: "Transfers",
      b2bTransfers: "B2B Transfers",
      assetMapping: "Asset Mapping",
      leiCustodyMapping: "LEI Custody Mapping",
      convertSettlement: "Convert Settlement",
      chargesOnFunds: "Charges on Funds",
      convertCharges: "Convert Charges",
    },
    transfers: {
      title: "Transfers",
      emptyMessage: "No transfer configurations",
      addRule: "Add transfer",
      noResults: "No transfers match your search or filters",
      searchPlaceholder: "Search",
      deleteConfirmHeader: "Are you sure you want to delete this?",
      deleteConfirmMessage: "Once deleted it cannot be restored.",
      deleteConfirmAccept: "Yes, confirm delete",
      deleteSuccess: "Transfer configuration deleted successfully",
      deleteFail: "Failed to delete transfer configuration",
      updateFail: "Failed to update transfer configuration",
      deleteConfirmReject: "No, cancel and go back",
      tables: {
        entity: "Entities (CCID)",
        interAccount: "Inter Account Transfers",
        brokerToBroker: "Broker to Broker Transfers (B2B)",
        crossCustomer: "Cross Customer Transfers",
        actionsHeader: "Actions",
      },
      tooltips: {
        entity: "The legal entity associated with the account and customer.",
        interAccount:
          "Enables transfers between accounts under the same LMAX legal entity.",
        brokerToBroker:
          "Enables transfers between accounts held under two different LMAX legal entities within the same customer entity.",
        crossCustomer:
          "Enable the movement of funds between distinct customer legal entities (Remittance Transfer).",
      },
    },
    mapping: {
      assetMapping: {
        title: "Asset Mapping",
        resourceNameSingular: "asset",
        resourceNamePlural: "assets",
        addAsset: "Add new asset",
        addAssetEmpty: "Add asset",
        addMapping: "Add mapping rule",
        addMappingEmpty: "Add mapping rule",
        save: "Save",
        search: "Search",
        back: "Back",
        view: "View",
        editMapping: "Edit",
        breadcrumb: "Asset Mapping",
        mappingsHeader: "Mappings",
        loading: "Loading...",
        notFound: "Asset not found.",
        columns: {
          assetName: "Asset Name",
          symbol: "Symbol",
          assetType: "Asset Type",
          actions: "Actions",
          type: "Type",
          domainMapping: "Domain Mapping",
          symbolMapping: "Symbol Mapping",
          blockchainMapping: "Blockchain Mapping",
        },
        empty: {
          overview: "Add an asset to start configuring",
          overviewReadonly: "No assets configured",
          mappingsTitle: "Add your first mapping rule",
          mappingsTitleReadonly: "No mapping rules",
        },
        types: {
          digital: "Digital",
          fiat: "Fiat",
        },
        unsavedChanges: {
          header: "You have unsaved changes",
          message:
            "Are you sure you want to leave? Any unsaved changes will be lost.",
          accept: "Leave without saving",
          reject: "Stay on page",
          incompleteSetupHeader: "You haven't finished configuring this asset",
          incompleteSetupMessage:
            "You need to add a mapping rule for this asset to save the setup",
          incompleteSetupStay: "Finish setup",
        },
        deleteConfirm: {
          header: "Are you sure you want to delete this mapping?",
          message: "Once deleted it cannot be restored",
          accept: "Yes confirm delete",
          reject: "No, cancel and go back",
        },
        errors: {
          saveFailed: "Failed to save asset mapping",
          saveSuccess: "Asset mapping saved successfully",
        },
        dialog: {
          addAsset: {
            title: "Add asset",
            editTitle: "Edit asset",
            description: "Assets can’t be edited after they are saved",
            fields: {
              name: "Asset name",
              symbol: "Symbol",
              type: "Type (Fiat / Digital)",
            },
            tooltips: {
              name: "The full name of the asset",
              symbol: "The currency code (ticker) for this asset",
              type: "Specifies whether this asset is a fiat currency or a digital asset",
            },
            placeholders: {
              name: "Enter asset name",
              symbol: "Enter symbol",
              type: "Select type",
            },
            confirm: "Confirm",
            cancel: "Cancel",
          },
          addMapping: {
            title: "Add mapping",
            editTitle: "Edit mapping",
            description: "",
            fields: {
              domain: "Domain",
              symbol: "Symbol",
              blockchain: "Blockchain",
            },
            tooltips: {
              domain: "The external system this asset belongs to",
              symbol: "The local currency code used by this system",
              blockchain:
                "The blockchain network supported by this system, if applicable (custody only)",
            },
            placeholders: {
              domain: "Select domain",
              symbol: "Enter symbol",
              blockchain:
                "Enter one or more Blockchain networks (use a comma to separate them)",
            },
            confirm: "Confirm",
            cancel: "Cancel",
          },
        },
      },
      leiCustody: {
        title: "Internal LEI Custody Mapping",
        emptyMessage: "Add a rule to start configuring",
        emptyMessageReadonly: "No custody mappings",
        leiEntityLabel: "LMAX Entity (Trade Participant ID)",
        leiEntityTooltip:
          "The internal LMAX entity associated with this custody account",
        custodyAccountLabel: "Custody Account",
        custodyAccountTooltip:
          "The internal custody account used for your internal brokers",
        leiEntityPlaceholder: "Select entity...",
        custodyAccountPlaceholder: "Select account...",
        loading: "Loading...",
        deleteConfirmHeader: "Are you sure you want to delete this?",
        deleteConfirmMessage: "Once deleted it cannot be restored",
        deleteConfirmAccept: "Yes confirm delete",
        deleteConfirmReject: "No, cancel and go back",
        deleteSuccess: "LEI custody mapping deleted successfully",
        deleteFail: "Failed to delete LEI custody mapping",
        saveSuccess: "LEI custody mapping saved successfully",
        saveFail: "Failed to save LEI custody mapping",
        saveDuplicateRows:
          "Duplicate LEI and product combinations found. Each combination must be unique.",
        savedOnPage: "See page { page } to view it",
        savedHiddenByFilters: "Hidden by your current filters",
        errorFetchConfig: "Error fetching LEI custody mappings",
        addRuleModalTitle: "Add a mapping rule",
        editRuleModalTitle: "Edit mapping rule",
        addRuleModalDescription:
          "Maps each internal Broker Legal Entity (e.g., LMAX Digital Broker) to the Custodian Account it operates from.",
        confirm: "Confirm",
        cancel: "Cancel",
        edit: "Edit",
        actionsHeader: "Actions",
        addMappingRule: "Add mapping rule",
        searchPlaceholder: "Search",
        resourceName: "mappings",
        invalidAccountSelection:
          "Selected custody account is missing product data. Please choose another account.",
        advancedSearchTitle: "Find custody account",
        advancedSearchSubtitle:
          "Search for the custody account that should be mapped to this LMAX entity.",
      },
      convertSettlement: {
        title: "Convert Settlement",
        emptyMessage: "Add a rule to start configuring",
        emptyMessageReadonly: "No settlement mappings",
        addRule: "Add mapping rule",
        leiEntityLabel: "LMAX Entity (Trade Participant ID)",
        leiEntityTooltip:
          "The internal LMAX entity associated with this settlement account",
        leiEntityPlaceholder: "Select entity",
        settlementAccountLabel: "Settlement Account",
        settlementAccountTooltip:
          "The Omnia account where settlement will take place",
        settlementAccountPlaceholder: "Find account",
        advancedSearchTitle: "Find settlement account",
        advancedSearchSubtitle:
          "Search for the settlement account that should receive auto-converted balances.",
        loading: "Loading...",
        deleteConfirmHeader: "Are you sure you want to delete this?",
        deleteConfirmMessage: "Once deleted it cannot be restored",
        deleteConfirmAccept: "Yes confirm delete",
        deleteConfirmReject: "No, cancel and go back",
        deleteSuccess: "Convert settlement mapping deleted successfully",
        deleteFail: "Failed to delete convert settlement mapping",
        saveSuccess: "Convert settlement mapping saved successfully",
        savedOnPage: "See page { page } to view it",
        savedHiddenByFilters: "Hidden by your current filters",
        saveFail: "Failed to save convert settlement mapping",
        saveDuplicateRows:
          "Duplicate LEI and product combinations found. Each combination must be unique.",
        errorFetchConfig: "Error fetching convert settlement mappings",
        addRuleModalTitle: "Add a mapping rule",
        editRuleModalTitle: "Edit mapping rule",
        addRuleModalDescription:
          "Maps each internal Broker Legal Entity (e.g., LMAX Digital Broker) to the Settlement Account it operates from.",
        confirm: "Confirm",
        cancel: "Cancel",
        edit: "Edit",
        actionsHeader: "Actions",
        searchPlaceholder: "Search",
        resourceName: "mappings",
      },
    },
    b2b: {
      title: "B2B Transfers",
      emptyMessage: "Add a rule to start configuring",
      emptyCta: "Add transfer rule",
      addModalTitle: "Add transfer rule",
      noResults: "No configurations match your search or filters",
      searchPlaceholder: "Search",
      deleteConfirmHeader: "Are you sure you want to delete this?",
      deleteConfirmMessage: "Once deleted it cannot be restored.",
      deleteConfirmAccept: "Yes, confirm delete",
      deleteConfirmReject: "No, cancel and go back",
      tables: {
        fromLei: "LMAX Entity 1",
        toLei: "LMAX Entity 2",
        requireApproval: "Approval Required",
        enableDigital: "Enable transfer of Digital Assets",
        enableFiat: "Enable transfer of Fiat Assets",
        actionsHeader: "Actions",
      },
      tooltips: {
        fromLei:
          "One of the LMAX legal entities, typically defined by jurisdiction.",
        toLei:
          "A second LMAX legal entity, distinct from Entity 1 and typically in a different jurisdiction.",
        requireApproval:
          "Indicates whether transfers from this entity require approval before processing.",
        enableDigital:
          "Allows the entity to transfer supported digital assets (e.g. crypto or tokens) between accounts.",
        enableFiat:
          "Allows the entity to transfer supported fiat currencies (e.g. USD, GBP, EUR) between accounts.",
        defaultState:
          "The default configuration applied to newly added entities. Existing entities are not affected.",
      },
      labels: {
        addConfigButton: "Add transfer rule",
      },
      form: {
        title: "Add B2B Configuration",
        buttons: {
          submit: "Add transfer rule",
        },
        confirm: {
          areYouSureDelete: {
            header:
              "Are you sure you want to delete the following configuration:",
            message:
              "LMAX Entity 1: { lmaxEntity1Name } ({ lmaxEntity1Id })\nLMAX Entity 2: { lmaxEntity2Name } ({ lmaxEntity2Id })",
          },
        },
        messages: {
          LEIS_SHOULD_BE_UNIQUE:
            "LMAX Entity 1 and LMAX Entity 2 are identical; they must be unique",
          errorFetchEntities: "Error fetching B2B transfer configurations",
          genericError: "B2B transfer configuration failed",
          createdConfigFailTitle: "Failed to add B2B transfer configuration",
          updateConfigFailTitle: "Failed to update B2B transfer configuration",
          deleteConfigFailTitle: "Failed to delete B2B transfer configuration",
          createdConfigSuccessTitle: "B2B transfer configuration created",
          createdConfigSuccessMessage:
            "New B2B transfer configuration successfully added",
        },
      },
    },
    chargesOnFunds: {
      deleteConfirmHeader: "Are you sure you want to delete this?",
      deleteConfirmMessage: "Once deleted it cannot be restored.",
      deleteConfirmAccept: "Yes, confirm delete",
      deleteConfirmReject: "No, cancel and go back",
      deleteSuccess: "Charges on funds configuration deleted successfully",
      deleteFail: "Failed to delete charges on funds configuration",
      emptyMessage: "Add an account to start configuring",
      emptyMessageReadonly: "No accounts configured",
      searchPlaceholder: "Search",
      view: "View",
      filters: {
        customerAccount: "Customer Account",
        product: "Product",
      },
      addAccount: {
        button: "Add an account",
        modalTitle: "Add new account",
        bannerMessage:
          "To complete configuration for charges on funds you’ll also need to add a default rule",
        customerAccountTitle: "Customer Account (Custodian)",
        customerAccountTooltip:
          "The customer's account that has been configured for Auto Transfer & Auto Convert",
        revenueAccountTitle: "Internal Revenue Account (Broker)",
        revenueAccountTooltip:
          "The house account designated to receive LMAX revenue generated",
        billingAccountTitle: "Billing Account (Broker)",
        billingAccountTooltip:
          "The customer account from which fees will be deducted",
        brokerAccountsMustDiffer:
          "Revenue and billing accounts must be different.",
      },
      detail: {
        save: "Save",
        edit: "Edit",
        editModalTitle: "Edit account",
        breadcrumbCurrent: "Account",
        customerAccountHeader: "Customer Account (Custodian)",
        revenueAccountHeader: "Internal Revenue Account (Broker)",
        billingAccountHeader: "Billing Account (Broker)",
        actionsHeader: "Actions",
        custodianTag: "Custodian",
        updateSuccess: "Accounts updated successfully",
        updateFail: "Failed to update accounts",
        notFound: "Configuration not found",
        unsavedChangesHeader: "You have unsaved changes",
        unsavedChangesMessage:
          "Are you sure you want to leave? Any unsaved changes will be lost.",
        unsavedChangesAccept: "Leave without saving",
        unsavedChangesReject: "Stay on page",
        incompleteSetupHeader: "You haven't finished configuring this account",
        incompleteSetupMessage:
          "You need to add a default rule for this account to save the setup",
        incompleteSetupStay: "Finish setup",
        commissionRules: {
          title: "Commission Rules",
          addOverrideCta: "Add commission rule",
          defaultRowLabel: "Default",
          empty: {
            message:
              "Add a default rule in order to add custom Commission Rules",
            messageReadonly: "No commission rules configured",
            cta: "Add default rule",
            bannerMessage:
              "Add a default rule to configure charges on this account",
          },
          columns: {
            asset: "Asset",
            depositCommission: "Deposit Commission ($/pm)",
            withdrawalCommission: "Withdrawal Commission ($/pm)",
            minimumDepositCommission: "Minimum Deposit Commission ($)",
            minimumWithdrawalCommission: "Minimum Withdrawal Commission ($)",
            actions: "Actions",
          },
          actions: {
            edit: "Edit",
            deleteLabel: "Delete rule",
          },
          modal: {
            cancel: "Cancel",
            confirm: "Confirm",
            default: {
              addTitle: "Set default rule",
              editTitle: "Edit default rule",
              description:
                "All transactions will be subject to this charge unless specific asset overrides are set.",
            },
            override: {
              addTitle: "Add commission rule",
              editTitle: "Edit commission rule",
            },
            fields: {
              asset: {
                label: "Asset",
                tooltip: "The asset this override rule applies to.",
              },
              deposit: {
                label: "Deposit Commission ($/pm)",
                tooltip:
                  "The commission charged on deposits, expressed in dollars per million",
              },
              withdrawal: {
                label: "Withdrawal Commission ($/pm)",
                tooltip:
                  "The commission charged on withdrawals, expressed in dollars per million",
              },
              minDeposit: {
                label: "Minimum Deposit Commission ($)",
                tooltip:
                  "The minimum commission amount a customer will be charged on any single deposit",
              },
              minWithdrawal: {
                label: "Minimum Withdrawal Commission ($)",
                tooltip:
                  "The minimum commission amount a customer will be charged on any single withdrawal",
              },
              amountPlaceholder: "Enter amount",
            },
          },
          deleteOverride: {
            header: "Delete this override?",
            message: "The default rule will apply to this asset instead.",
          },
          saveSuccess: "Commission rules saved successfully",
          saveFail: "Failed to save commission rules",
        },
      },
    },
    convertCharges: {
      deleteConfirmHeader: "Are you sure you want to delete this?",
      deleteConfirmMessage: "Once deleted it cannot be restored.",
      deleteConfirmAccept: "Yes, confirm delete",
      deleteConfirmReject: "No, cancel and go back",
      deleteSuccess: "Convert charges configuration deleted successfully",
      deleteFail: "Failed to delete convert charges configuration",
      emptyMessage: "Add an account to start configuring",
      emptyMessageReadonly: "No accounts configured",
      searchPlaceholder: "Search",
      view: "View",
      filters: {
        customerAccount: "Customer Account",
        product: "Product",
      },
      addAccount: {
        button: "Add an account",
        modalTitle: "Add new account",
        bannerMessage:
          "To complete configuration for convert charges you’ll also need to add a default rule",
        customerAccountTitle: "Customer Account (Custodian)",
        customerAccountTooltip:
          "The custodian customer account to configure convert charges for.",
        revenueAccountTitle: "Internal Revenue Account (Broker)",
        revenueAccountTooltip:
          "The house account designated to receive LMAX revenue generated",
        billingAccountTitle: "Billing Account (If applicable)",
        billingAccountTooltip:
          "The customer account from which fees will be deducted",
        brokerAccountsMustDiffer:
          "Revenue and billing accounts must be different.",
      },
      detail: {
        save: "Save",
        edit: "Edit",
        editModalTitle: "Edit account",
        breadcrumbCurrent: "Account",
        customerAccountHeader: "Customer Account (Custodian)",
        revenueAccountHeader: "Internal Revenue Account (Broker)",
        billingAccountHeader: "Billing Account (Broker)",
        actionsHeader: "Actions",
        custodianTag: "Custodian",
        commissionInSpread: "Commission in spread",
        updateSuccess: "Accounts updated successfully",
        updateFail: "Failed to update accounts",
        notFound: "Configuration not found",
        unsavedChangesHeader: "You have unsaved changes",
        unsavedChangesMessage:
          "Are you sure you want to leave? Any unsaved changes will be lost.",
        unsavedChangesAccept: "Leave without saving",
        unsavedChangesReject: "Stay on page",
        incompleteSetupHeader: "You haven't finished configuring this account",
        incompleteSetupMessage:
          "You need to add a default rule for this account to save the setup",
        incompleteSetupStay: "Finish setup",
        commissionRules: {
          title: "Convert Commission Rules",
          addOverrideCta: "Add commission rule",
          defaultRowLabel: "Default",
          empty: {
            message:
              "Add a default to start configuring asset-specific commission rules.",
            messageReadonly: "No commission rules configured",
            cta: "Add default rule",
            bannerMessage:
              "Add a default rule to configure convert charges on this account",
          },
          settlementPrice: {
            oneToOne: "1:1",
            marketPrice: "Market Price",
            marketPricePlusSpread: "Market Price + Spread",
          },
          columns: {
            asset: "Asset",
            settlementPrice: "Settlement Price",
            commission: "Commission ($/M)",
            actions: "Actions",
          },
          actions: {
            edit: "Edit",
            deleteLabel: "Delete rule",
          },
          modal: {
            cancel: "Cancel",
            confirm: "Confirm",
            default: {
              addTitle: "Set default rule",
              editTitle: "Edit default rule",
            },
            override: {
              addTitle: "Add Convert Charge Rule",
              editTitle: "Edit Convert Charge Rule",
            },
            fields: {
              asset: {
                label: "Asset",
                tooltip: "The asset this convert charge rule applies to.",
              },
              settlementPrice: {
                label: "Settlement Price",
                tooltip:
                  "The settlement price model used when charging this rule.",
                placeholder: "Select a settlement price",
              },
              commission: {
                label: "Commission ($/M)",
                tooltip: "The commission charged per million for this rule.",
                placeholder: "0",
              },
            },
          },
          deleteOverride: {
            header: "Delete this override?",
            message: "The default rule will apply to this asset instead.",
          },
          saveSuccess: "Convert commission rules saved successfully",
          saveFail: "Failed to save convert commission rules",
        },
      },
    },
  },
  docs: {
    pageTitle: "Support & Docs",
    support: {
      title: "Support",
      text: "Get in touch with an LMAX Portal expert",
      email: "info@lmax.com",
    },
    apiDocs: {
      title: "API Docs",
      text: "Guidance to connect to Portal API",
      label: "Go to API docs",
      url: "https://api.risk-hub.lmax.com/docs/platform/index.html",
    },
    faqs: {
      title: "FAQs",
      items: [
        {
          title: "What does this portal do?",
          content: [
            "This is a unified platform that gives you complete visibility across all your LMAX accounts.",
            "It removes the limitations of account-level views by allowing you to perform key actions like transferring assets between accounts directly within the portal.",
            "This makes managing your portfolio faster, simpler, and more efficient.",
          ],
        },
        {
          title: "Can I transfer assets between my accounts?",
          content: [
            "Yes.",
            "You can transfer supported digital assets (e.g. BTC, ETH, USDT) and fiat currencies (e.g. USD, GBP, EUR) between accounts, subject to your legal entity permissions.",
          ],
        },
        {
          title: "Do I still need to contact support for transfers?",
          content: [
            "No.",
            "Transfers can now be initiated directly from the portal.",
            "For complex or restricted transfers, your LMAX account manager or Customer Support team can assist.",
          ],
        },
        {
          title: "How are valuations calculated on the dashboard?",
          content: [
            "Valuations are estimated based on recent market pricing.",
            "Final values may vary depending on execution timing, spreads, and market conditions.",
          ],
        },
        {
          title: "Why can’t I see all my accounts?",
          content: [
            "If an account is missing, it may not be linked to your LMAX SSO profile.",
            "You’ll need to authenticate and add the account to your SSO to view it in the portal.",
          ],
        },
      ],
    },
  },
};
